import { RightCircleFilled } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { Store } from 'antd/lib/form/interface';
import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputPassword from 'components/atoms/InputPassword';
import Title from 'components/atoms/Title';
import AuthWrapper from 'components/base/AuthWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { useNewPassword } from 'hooks/useNewPassword';

import passwordRestoreApi from 'services/passwordRestore';

import routePathEnum from 'enums/routePathEnum';

import passwordCheckValidation from 'utils/validations/passwordCheckValidation';

interface IObnoveniHesla {}

const ObnoveniHesla: React.FC<IObnoveniHesla> = () => {
    const [form] = useForm();
    const { PasswordInput, isStrongEnough } = useNewPassword('password');
    const { language } = useContext(Context);
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState<boolean>(false);
    const [status, setStatus] = useState<number>(0);
    const onFinish = ({ password }: Store) => {
        setLoading(val => !val);
        passwordRestoreApi(password, id!, language)
            .then(resp => setStatus(resp))
            .catch(err => setStatus(err.response.status))
            .finally(() => {
                setLoading(val => !val);
            });
    };
    const okReturn = () => (
        <div
            style={{
                textAlign: 'center'
            }}
        >
            <Row>
                <Col span={24}>
                    <Title text="EMP_INFO_ZMENA_OBNOVENI_HESLO" level={4} />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <TranslateText>EMP_POTVRZENI_EMAIL_200</TranslateText>
                </Col>
            </Row>
            <AnchorComponent link={true} to={routePathEnum.LOGIN_ROZCESTNIK}>
                <ButtonComponent buttontext="ZPET" type="default" id="obnoveniHeslaZpetBtn" />
            </AnchorComponent>
        </div>
    );

    const errReturn = () => (
        <Row justify="center">
            <AnchorComponent link={true} to={routePathEnum.ZADOST_OBNOVENI_HESLA} id="obnoveniHeslaRedirect">
                <TranslateText>HESLO_ZMENA_401</TranslateText>
            </AnchorComponent>
        </Row>
    );

    const defaultReturn = () => (
        <FormWrapper onFinish={onFinish} outForm={form}>
            <Title text="HESLO_NOVE_NADPIS" level={3} />
            <TranslateText>HESLO_ZMENA_TEST_ALT</TranslateText>
            {PasswordInput()}
            <InputPassword
                label="HESLO_NOVE_OVERENI"
                name="passwordCheck"
                type="password"
                dependencies={['password']}
                rules={passwordCheckValidation('password')}
            />

            <ButtonComponent
                buttontext="POKRACOVAT"
                onClick={() => form.submit()}
                icon={<RightCircleFilled />}
                loading={loading}
                id="obnoveniHeslaSubmitBtn"
                disabled={!isStrongEnough}
            />
        </FormWrapper>
    );

    return (
        <AuthWrapper>
            {!status && defaultReturn()}
            {status === 200 && okReturn()}
            {status === 401 && errReturn()}
        </AuthWrapper>
    );
};

export default ObnoveniHesla;
